import { createDraftSafeSelector } from "@reduxjs/toolkit";
import { RootState } from "@/redux/store";
import { CartState } from "@/redux/slice/cart/types/CartState";
import { selectCartItemCount } from "@/redux/slice/cart/selectors/cartItems";

const selectCart = (state: RootState) => state?.cart;

const selectAuth = (state: RootState) => state?.auth;

const selectCurrentPatientId = createDraftSafeSelector(selectAuth, (auth) => auth?.currentPatientId);

const computeTotalCartItemCount = (cart: CartState, cartItemCount: number, currentPatientId: string) => {
  if (currentPatientId) {
    return cart?.totalCartItemCount || cartItemCount || 0;
  }

  return cartItemCount || 0;
};

export default createDraftSafeSelector(
  [selectCart, selectCartItemCount, selectCurrentPatientId],
  computeTotalCartItemCount
);
